import {AppLoggedIn} from './AppLoggedIn'
import {useAuthentication} from './common/auth/hooks/useAuthentication'
import {Header} from './common/header/Header'

import {Notification} from './common/notifications/Notification'
import {Box} from './webui/Box'
import {LoginForm} from './webui/LoginForm'

function App() {
  const {currentUser, userLoggedIn} = useAuthentication()

  return (
    <div className="App" style={{display: 'flex', flexDirection: 'column', gap: 20}}>
      {userLoggedIn ? (
        <>
          <Header user={currentUser} />
          <AppLoggedIn />
        </>
      ) : (
        <LoginForm />
      )}

      <Box m={2}>
        <>
          <Notification />
        </>
      </Box>
    </div>
  )
}

export default App
